export default __webpack_public_path__ + "static/media/Boots of the Sepulcher.98178488.jpg";